module.exports = __webpack_public_path__ + "static/fiddle-d7e77c32876b01fff678ca353302e4c6.jpg";